<template>

  <transition-group>
    <div class="scroll-post__slide"
         v-for="slide in slides"
         :key="slide.id"
         :style="getStyle(slide)" >
      <div
        class="scroll-post__video-container"
        v-if="slide.video"
        :style="getVideoStyle(slide)"
        >
        <video
          v-if="slide.video"
          class="scroll-post__video"
          autoPlay
          playsinline
          muted
          loop
          :src="slide.video.url"
          />
      </div>
  </div>
</transition-group>
</template>

<script>

  export default {
    props: ['slides', 'getPercent'],
    methods: {

      getVideoStyle(slide) {
        const {position, relativePosition, relativePositionFloat} = this.getPercent(slide);
        const top = (relativePositionFloat) * 60;
        return {
          marginTop: `${top}px`,
        }
      },
      getStyle(slide) {
        const {position, relativePosition, relativePositionFloat} = this.getPercent(slide);
        const top = (relativePositionFloat) * 60;
        const opacityFactor = relativePosition === 0 && relativePositionFloat - relativePosition < 0.9 && relativePositionFloat - relativePosition > -0.9 ? 0 : relativePositionFloat;
        const opacity = 1 - 1 * Math.pow(relativePositionFloat, 2);
        const display = opacity <= 0 ? 'none' : undefined;
        return {
          opacity,
          display,
          backgroundImage: !slide.video && slide.img ? `url('${slide.img}')` : null,
          backgroundPositionY: `calc(50% + ${top}px)`,
        };
      },

    },
  };
</script>

